/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 * TextBlockStatus component for show status icon with children
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.10.0
 */

import { FC } from 'react';

import { icons } from '../../../assets';
import { ImgStyled } from '../Block/Img';
import { TextBlockStatusStyled } from './styled/TextBlockStatusStyled';
import { ETextBlockStatus } from './textBlockStatusTypes';

interface ITextBlockStatusProps {
    status: ETextBlockStatus;
}

const TextBlockStatus: FC<ITextBlockStatusProps> = (props) => (
    <TextBlockStatusStyled>
        {
            {
                [ETextBlockStatus.ERROR]: (
                    <ImgStyled className="status-icon" src={icons.infoErrorSmallIcon} width="20px" />
                ),
                [ETextBlockStatus.OK]: (
                    <ImgStyled className="status-icon" src={icons.infoSuccessSmallIcon} width="20px" />
                ),
                [ETextBlockStatus.PARTIALLY]: (
                    <ImgStyled className="status-icon" src={icons.infoWarningSmallIcon} width="20px" />
                ),
                [ETextBlockStatus.WARNING]: (
                    <ImgStyled className="status-icon" src={icons.infoWarningSmallIcon} width="20px" />
                ),
                [ETextBlockStatus.CHANGE]: (
                    <ImgStyled className="status-icon" src={icons.infoSuccessSmallIcon} width="20px" />
                ),
            }[props.status]
        }
        {props.children}
    </TextBlockStatusStyled>
);

export default TextBlockStatus;
